import globalStyles from './App.module.scss';

export default function PrivacyLink() {
    return (
        <p className={globalStyles.smallInfoText}>
            Les <a href="https://www.skiforeningen.no/omoss/personvern/">Skiforeningens personvernerklæring</a>.
        </p>
    );
}
